export default "__VITE_ASSET__BIH6j5k___";